
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { CompanyAccountingSettingModel } from 'models/generated/Entities.Accounting.CompanyAccountingSetting';


const _accounting_CompanyAccountingSettingsControllerHelper = new Map<string, Object>();
_accounting_CompanyAccountingSettingsControllerHelper.set('GetCompanyAccountingSettings', CompanyAccountingSettingModel);
_accounting_CompanyAccountingSettingsControllerHelper.set('FindByCustomerNo', CompanyAccountingSettingModel);
_accounting_CompanyAccountingSettingsControllerHelper.set('FindByCustomerNumbers', CompanyAccountingSettingModel);


export const accounting_CompanyAccountingSettingsControllerHelper = _accounting_CompanyAccountingSettingsControllerHelper;

